//import axios from 'axios';
import axios, {API_URL} from '../utils/axios'

const API_URL_VERSION = API_URL + "/v1/admin/";

const buildClinicQuery = ({ sortBy, sortOrder, searchField, searchTerm, typeFilter, statusFilter }) => {
    const parts = [];
    const effectiveSortBy = sortBy || 'name';

    parts.push(`sortBy==${effectiveSortBy}`);
    parts.push(`sortOrder==${(sortOrder || 'asc').toUpperCase()}`);

    if (searchTerm?.trim()) {
        const field = searchField || 'name';
        parts.push(`${field}==*${searchTerm.trim()}*`);
    }
    if (typeFilter) {
        parts.push(`clinicType==${typeFilter}`);
    }
    if (statusFilter) {
        parts.push(`status==${statusFilter}`);
    }

    return parts.join(',');
};

const getAllClinics = (pageNo = 0, pageSize = 20, queryOptions = {}) => {
    const params = {
        pageNo,
        pageSize,
    };
    const q = buildClinicQuery(queryOptions);
    if (q) {
        params.q = q;
    }
    return axios.get(`${API_URL_VERSION}clinics`, { params });
};
const getAllClinicsFast = () => {
    return axios.get(API_URL_VERSION + "template-clinics");
}

const getClinicById = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id);
}
const addClinic = ({name, email, phone, sms, logo, signature, website, assetName}) => {
    return axios
        .post(API_URL_VERSION + "clinics", {
            name,
            email,
            phone,
            sms,
            logo,
            signature,
            website,
            assetName
        })

}
const updateClinic = (id, data) => {
    return axios.put(API_URL_VERSION + "clinics/" + id, data)
}

const patchClinic = (id, status) => {
    return axios.patch(API_URL_VERSION + `clinics/${id}?status=${status}`)
};

const getClinicAccountStatus = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/account-status")
}
const getAllTimeZones = () => {
    return axios.get(API_URL_VERSION + "timezones");
}
const updateTimezone = (id, data) => {

    return axios.post(API_URL_VERSION + "clinics/" + id + "/timezone/" + data.timezoneid)
}
const getTimeZone = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/timezone");
}
const getAddress = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/address");
}
const updateAddress = (id, data) => {
    return axios.post(API_URL_VERSION + "clinics/" + id + "/address", data);
}
const addAddress = (id, data) => {
    return axios.post(API_URL_VERSION + "clinics/" + id + "/address", data);
}
const getHours = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/hours");
}
const updateHours = (id, data) => {
    return axios
        .post(API_URL_VERSION + "clinics/" + id + "/hours", data);
}
const deleteHours = (id, data) => {
    return axios
        .delete(API_URL_VERSION + "clinics/" + id + "/hours", {data: data});
}

const getSettings = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/features")
}
const updateSettings = (id, data) => {
    return axios.put(API_URL_VERSION + "clinics/" + id + "/features", data)
}


const getUpdates = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/updates");
}
const getVerification = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/verification");
}
const updateVerification = (id, data) => {
    return axios
        .put(API_URL_VERSION + "clinics/" + id + "/verifications", data)
}
const sendVerification = (id, data) => {
    return axios
        .get(API_URL_VERSION + "clinics/" + id + "/verifications?type=" + data);
}
const getReminderSettings = (id) => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/reminder-settings");
}
const updateReminderSettings = (id, data) => {
    return axios
        .put(API_URL_VERSION + "clinics/" + id + "/reminder-settings", data)
}
const addAuth = (id, data) => {
    return axios
        .post(API_URL_VERSION + "users/" + id + "/auth", data)
}

const getUserAuth = (id) => {
    return axios
        .get(API_URL_VERSION + "users/" + id + "/auth")
}
const updateUserAuth = (id, data) => {
    return axios
        .put(API_URL_VERSION + "users/" + id + "/auth", data)
}

const getCustomization = (clinicid) => {
    return axios
        .get(API_URL_VERSION + "clinics/" + clinicid + "/customizes")
}
const updateCustomization = (clinicid, data) => {
    return axios
        .post(API_URL_VERSION + "clinics/" + clinicid + "/customizes", data)
}
const deleteCustomization = (clinicid, customid) => {
    return axios
        .delete(API_URL_VERSION + "clinics/" + clinicid + "/customizes/" + customid)
}
const getSocialLinks = (clinicid) => {
    console.log("Social Links url : " + API_URL_VERSION + "clinics/" + clinicid + "/social-links")
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/social-links")
}
const updateSocialLinks = (clinicid, data) => {
    return axios.post(API_URL_VERSION + "clinics/" + clinicid + "/social-links", data)
}
const deleteSocialLink = (clinicid, linkid) => {
    return axios.delete(API_URL_VERSION + "clinics/" + clinicid + "/social-links/" + linkid)
}
const getLens = (clinicid) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/cl-brands")
}
const addUpdateLens = (clinicid, data) => {
    return axios.post(API_URL_VERSION + "clinics/" + clinicid + "/cl-brands", data)
}
const deleteLens = (clinicid, id) => {
    return axios.delete(API_URL_VERSION + "clinics/" + clinicid + "/cl-brands/" + id)
}
const getMedia = (clinicid) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/resources")
}
const deleteMedia = (clinicid, data) => {
    return axios.delete(API_URL_VERSION + "clinics/" + clinicid + "/resources", {data: data})
}
const uploadMedia = (clinicid, formData, uploadProgress) => {
    return axios.post(API_URL_VERSION + "clinics/" + clinicid + "/resources", formData, {
        onUploadProgress: uploadProgress,
        isMultipart: true
    })
}
//Reputation
const getReputationClinic = (clinicid) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/reputation-enhancements")
}
const getReputationLinks = (clinicid) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/reputation-enhancements/links")
}
const getReputationFeedbacks = (clinicid, pageNo = 0, pageSize = 10) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/reputation-enhancements/feedbacks?pageNo=" + pageNo + "&pageSize=" + pageSize)
}
const getReputationComments = (clinicid, pageNo = 0, pageSize = 10) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/reputation-enhancements/comments?pageNo=" + pageNo + "&pageSize=" + pageSize)
}
const addReputationClinic = (clinicid, data) => {
    return axios.post(API_URL_VERSION + "clinics/" + clinicid + "/reputation-enhancements", data)
}
const addUpdateReputationLink = (clinicid, data) => {
    return axios.post(API_URL_VERSION + "clinics/" + clinicid + "/reputation-enhancements/links", data)
}
const deleteReputationLink = (clinicid, linkid) => {
    return axios.delete(API_URL_VERSION + "clinics/" + clinicid + "/reputation-enhancements/links/" + linkid)
}
//Hostory
const getHistory = (clinicid, pageNo = 0, pageSize = 10) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/update-history?pageNo=" + pageNo + "&pageSize=" + pageSize)
}
//stats
const getPatientStats = (clinicid) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/patient-stats")
}
//assets
const getAssets = (clinicid) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/assets")
}
const saveAssets = (clinicid, data) => {
    return axios.post(API_URL_VERSION + "clinics/" + clinicid + "/assets", data)
}
const getUsers = (id, role = "ALL") => {
    return axios.get(API_URL_VERSION + "clinics/" + id + "/users?role=" + role);
}

const getDocuments = (clinicId, no = 0, size = 10) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicId + "/documents?pageNo=" + no + "&pageSize=" + size)
}

export const uploadDocument = (clinicId, formData) => {
    return axios.post(API_URL_VERSION + "clinics/" + clinicId + "/documents", formData, {
        isMultipart: true
    });
};

const getDocumentById = (clinicId, documentId) =>{
    return axios.get(API_URL_VERSION + "clinics/" + clinicId + "/documents/" + documentId, {
        responseType: 'blob', // Specify responseType as blob
    })
}

const deleteDocumentById = (clinicId, documentId) => {
    return axios.delete(API_URL_VERSION + "clinics/" + clinicId + "/documents/" + documentId)
}

const getPublicTheme = (clinicid) => {
    return axios.get(API_URL_VERSION + "clinics/" + clinicid + "/theme")
}

const updatePublicTheme = (clinicid, themeContent) => {
    return axios.post(API_URL_VERSION + "clinics/" + clinicid + "/theme", { themeContent })
}

const clinicService = {
    getAllClinics,
    getAllClinicsFast,
    getClinicById,
    addClinic,
    updateClinic,
    patchClinic,
    getClinicAccountStatus,
    getAllTimeZones,
    getTimeZone,
    updateTimezone,
    getAddress,
    updateAddress,
    addAddress,
    getHours,
    updateHours,
    deleteHours,
    getSettings,
    updateSettings,
    getUpdates,
    getVerification,
    updateVerification,
    sendVerification,
    getReminderSettings,
    updateReminderSettings,
    addAuth,
    getUserAuth,
    updateUserAuth,
    getCustomization,
    updateCustomization,
    deleteCustomization,
    getSocialLinks,
    updateSocialLinks,
    deleteSocialLink,
    getLens,
    addUpdateLens,
    deleteLens,
    getMedia,
    deleteMedia,
    uploadMedia,
    getReputationClinic,
    getReputationLinks,
    getReputationFeedbacks,
    getReputationComments,
    addReputationClinic,
    addUpdateReputationLink,
    deleteReputationLink,
    getHistory,
    getPatientStats,
    getAssets,
    saveAssets,
    getUsers,
    getDocuments,
    uploadDocument,
    getDocumentById,
    deleteDocumentById,
    getPublicTheme,
    updatePublicTheme
}

export default clinicService;